import reducer from "../common";

export default reducer("GET_ROBOT_CONNECTION_LOGS", []);
